import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import localsearchLogo from '../../assets/branding/localsearch-logo.jpg';
import config from '../../../src/client/config';

const { urlRoot } = config;

const Meta = ({ canonical, description, state, name, fullStateName }) => {
  return (
    <Helmet>
      <title>{`Find Local Businesses in ${name} ${state} with Reviews | Localsearch`}</title>
      <meta name="description" content={description} />
      <meta name="COPYRIGHT" content="Localsearch" />
      <meta name="AUTHOR" content="Localsearch" />
      <meta name="RESOURCE-TYPE" content="DOCUMENT" />
      <meta name="DISTRIBUTION" content="GLOBAL" />
      <meta name="RATING" content="GENERAL" />
      <meta property="og:title" content={`${name} ${fullStateName}`} />
      <meta property="og:type" content="company" />
      <meta property="og:image" content={`${urlRoot}/${localsearchLogo}`} />
      <meta property="og:url" content={urlRoot} />
      <meta property="og:site_name" content="Localsearch" />
      <meta property="og:description" content={description} />
      <link rel="canonical" href={`${urlRoot}${canonical}`} />
    </Helmet>
  );
};

Meta.propTypes = {
  canonical: PropTypes.string,
};

Meta.defaultProps = {
  canonical: '',
};

export default Meta;
